import { SplitCellsOutlined } from "@ant-design/icons";

import "./ResponseHeader.scss";
import { ButtonDelete } from "../../../ButtonDelete";
import { useFlowNodes } from "../../../../context";
import { handleResponseIntentNode } from "../../../utils/removeDataNode";

const ResponseHeader = ({ id }) => {
  const { t, setNodes, setEdges, updateIntent, updateContexts } =
    useFlowNodes();

  return (
    <div className="response-header">
      <div className="response-icon">
        <SplitCellsOutlined />
      </div>

      <div className="response-title-wrapper">
        <span className="response-title">
          {t("common:intents.flow_chat.response.title")}
        </span>
      </div>

      <div className="response-delete-button">
        <ButtonDelete
          setNodes={setNodes}
          setEdges={setEdges}
          nodeId={id}
          handleDelete={() =>
            handleResponseIntentNode(updateIntent, updateContexts)
          }
        />
      </div>
    </div>
  );
};

export default ResponseHeader;
